class Product extends HTMLElement {
  constructor() {
    super();

    this.productForm();
    this.productTabs();
    this.productQuantity();
    this.productImagesCarousel();
    this.productZoom();
    this.productStickyBar();
  }

  productForm() {
    const variants = (productId, sectionId) => {
      const data = JSON.parse(document.getElementById(`ProductJson${productId}`).innerHTML);

      const selectCallback = (variant) => {
        const that = this.querySelector(`.js-product[data-product-id='${productId}']`);

        if (variant) {
          const priceOldElement = that.querySelector(".js-price-old");
          const priceNewElement = that.querySelector(".js-price-new");
          const priceDefaultElement = that.querySelector(".js-price-default");
          const priceLowestElement = that.querySelector(".js-price-lowest");
          const priceLowestWrapperElement = that.querySelector(".js-wrapper-lowest-price");

          if (variant.compare_at_price > variant.price) {
            if (priceOldElement) {
              priceOldElement.classList.remove("d-none");
              priceOldElement.innerHTML = Shopify.formatMoney(variant.compare_at_price);
            }
            if(priceLowestWrapperElement && priceLowestElement) {
              priceLowestWrapperElement.classList.remove("d-none");
              priceLowestElement.innerHTML = Shopify.formatMoney(variant.price);
            }
            if (priceNewElement) {
              priceNewElement.classList.remove("d-none");
              priceNewElement.innerHTML = Shopify.formatMoney(variant.price);
            }
            if (priceDefaultElement) {
              priceDefaultElement.classList.add("d-none");
            }
          } else {
            if (priceOldElement) priceOldElement.classList.add("d-none");
            if (priceNewElement) priceNewElement.classList.add("d-none");
            if (priceDefaultElement) {
              priceDefaultElement.classList.remove("d-none");
              priceDefaultElement.innerHTML = Shopify.formatMoney(variant.price);
            }
            if(priceLowestWrapperElement) {
              priceLowestWrapperElement.classList.add("d-none");
            }
          }

          const soldOutWrappers = that.querySelectorAll('.js-wrap-sold-out');
          const addToCartWrappers = that.querySelectorAll('.js-wrap-add-to-cart, .product__quantity');

          if (!variant.available) {
            soldOutWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));
            addToCartWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
          } else {
            soldOutWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
            addToCartWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));
          }

          const fixedBar = document.querySelector('.js-product-fixed-bar');
          if(fixedBar) {
            const barPriceOld = fixedBar.querySelector(".js-bar-price-old");
            const barPriceNew = fixedBar.querySelector(".js-bar-price-new");
            const barPriceDefault = fixedBar.querySelector(".js-bar-price-default");
            const barPriceLowest = fixedBar.querySelector(".js-bar-price-lowest");
            const barPriceLowestWrapper = fixedBar.querySelector(".js-bar-wrapper-lowest-price");

            const barSoldOutWrappers = fixedBar.querySelectorAll('.js-bar-wrap-sold-out');
            const barAddToCartWrappers = fixedBar.querySelectorAll('.js-bar-wrap-add-to-cart, .product__quantity');

            if (variant.compare_at_price > variant.price) {
              if (barPriceOld) {
                barPriceOld.classList.remove("d-none");
                barPriceOld.innerHTML = Shopify.formatMoney(variant.compare_at_price);
              }
              if (barPriceLowestWrapper && barPriceLowest) {
                barPriceLowestWrapper.classList.remove("d-none");
                barPriceLowest.innerHTML = Shopify.formatMoney(variant.price);
              }
              if (barPriceNew) {
                barPriceNew.classList.remove("d-none");
                barPriceNew.innerHTML = Shopify.formatMoney(variant.price);
              }
              if (barPriceDefault) {
                barPriceDefault.classList.add("d-none");
              }
            } else {
              if (barPriceOld) barPriceOld.classList.add("d-none");
              if (barPriceNew) barPriceNew.classList.add("d-none");
              if (barPriceDefault) {
                barPriceDefault.classList.remove("d-none");
                barPriceDefault.innerHTML = Shopify.formatMoney(variant.price);
              }
              if (barPriceLowestWrapper) barPriceLowestWrapper.classList.add("d-none");
            }

            if (!variant.available) {
              barSoldOutWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));
              barAddToCartWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
            } else {
              barSoldOutWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
              barAddToCartWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));
            }
          }

          that.querySelectorAll('.js-product-size').forEach(sizeElement => {
            let soldOut = true;
            const value = sizeElement.getAttribute('data-value');
            const option = sizeElement.getAttribute('data-option');

            const selectedOptions = {};
            that.querySelectorAll(`.selector-wrapper select`).forEach(select => {
              const optionName = select.getAttribute('data-option');
              if(optionName != option) {
                selectedOptions[optionName] = select.value;
              }
            });

            that.querySelectorAll(`select[name='id'] option`).forEach(option => {
              const option1 = option.getAttribute('data-option-1');
              const option2 = option.getAttribute('data-option-2');
              const option3 = option.getAttribute('data-option-3');

              const matchesSelectedOptions =
                  (!selectedOptions['option1'] || option1 === selectedOptions['option1']) &&
                  (!selectedOptions['option2'] || option2 === selectedOptions['option2']) &&
                  (!selectedOptions['option3'] || option3 === selectedOptions['option3']);

              if (matchesSelectedOptions && (option1 === value || option2 === value || option3 === value)) {
                if (!option.hasAttribute('disabled')) {
                  soldOut = false;
                }
              }
            });

            if (soldOut) {
              sizeElement.classList.add('out-of-stock');
            } else {
              sizeElement.classList.remove('out-of-stock');
            }
          });
        }
      };

      if (document.getElementById(`product-select-${productId}`)) {
        new Shopify.OptionSelectors(`product-select-${productId}`, {
          product: data,
          onVariantSelected: selectCallback,
          enableHistoryState: true
        });
      }
    };

    document.querySelectorAll(".js-product:not(.active)").forEach((element) => {
      const productId = element.getAttribute("data-product-id");
      const json = document.getElementById(`ProductJson${productId}`);

      if (json) {
        variants(productId);

        element.querySelectorAll('.js-product-size').forEach(sizeElement => {
          sizeElement.addEventListener('click', function (event) {
            event.preventDefault();

            const value = this.getAttribute('data-value');
            const option = this.closest('ul').getAttribute('data-option');

            const productVariants = document.querySelector(`.js-product[data-product-id='${productId}'] select[data-option='${option}']`);
            if (productVariants) {
              productVariants.value = value;
              productVariants.dispatchEvent(new Event('change'));

              const optionValues = document.querySelectorAll(`.js-product[data-product-id='${productId}'] .js-product-size[data-option="${option}"]`);
              if (optionValues.length) {
                optionValues.forEach(optionValue => {
                  optionValue.classList.remove('active');
                });

                this.classList.add('active');
              }
            }

            const currentSizeEl = this.closest('.js-product-option').querySelector('.js-current-size-value');
            if (currentSizeEl) {
              currentSizeEl.textContent = value;
            }
          });
        });
      }

      element.classList.add("active");
    });
  }

  productTabs() {
    const DURATION = 300;

    const toggleAccordion = (toggle) => {
      const parent = toggle.closest('.js-product-accordion-item') || toggle.parentElement;
      if (!parent) return;

      parent.classList.toggle('active');

      const content = parent.querySelector('.js-product-accordion-content');
      if (!content || content.dataset.animating === 'true') return;

      const isOpen = content.classList.contains('is-open');
      content.dataset.animating = 'true';

      if (isOpen) {
        const startHeight = content.scrollHeight;
        content.style.height = startHeight + 'px';
        content.offsetHeight;
        content.style.transition = `height ${DURATION}ms ease`;
        content.style.height = '0px';

        setTimeout(() => {
          content.style.display = 'none';
          content.style.height = '';
          content.classList.remove('is-open');
          content.dataset.animating = 'false';
        }, DURATION);
      } else {
        content.style.display = 'block';
        const targetHeight = content.scrollHeight;

        content.style.height = '0px';
        content.offsetHeight;
        content.style.transition = `height ${DURATION}ms ease`;
        content.style.height = targetHeight + 'px';

        setTimeout(() => {
          content.style.height = '';
          content.classList.add('is-open');
          content.dataset.animating = 'false';
        }, DURATION);
      }
    };

    this.addEventListener('click', (event) => {
      const toggle = event.target.closest('.js-toggle-product-accordion');
      if (toggle) toggleAccordion(toggle);
    });

    this.addEventListener('keydown', (event) => {
      const toggle = event.target.closest('.js-toggle-product-accordion');
      if (!toggle) return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleAccordion(toggle);
      }
    });
  }

  productQuantity() {
    const changeQuantity = (wrapper, delta) => {
      if (!wrapper) return;

      const input = wrapper.querySelector('.js-quantity-field');
      if (!input) return;

      const min = parseInt(input.getAttribute('min') || '1', 10);
      const maxAttr = input.getAttribute('max');
      const max = maxAttr ? parseInt(maxAttr, 10) : null;

      let value = parseInt(input.value || '1', 10);
      if (isNaN(value)) value = min;

      value += delta;
      if (value < min) value = min;
      if (max !== null && value > max) value = max;

      input.value = value;

      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    };

    this.addEventListener('click', (event) => {
      const minus = event.target.closest('.js-quantity-down');
      const plus = event.target.closest('.js-quantity-up');

      if (!minus && !plus) return;

      event.preventDefault();

      const wrapper = (minus || plus).closest('.product__quantity');
      if (minus) {
        changeQuantity(wrapper, -1);
      } else if (plus) {
        changeQuantity(wrapper, +1);
      }
    });
  }

  productImagesCarousel() {
    const BREAKPOINT = 992;
    const wrapper = this.querySelector('.product__media-wrapper');

    if (!wrapper) return;

    const originalItems = Array.from(wrapper.children).filter(
      (el) => el.nodeType === 1
    );

    let splideInstance = null;
    let resizeTimer = null;

    function buildSplideStructure() {
      const splide = document.createElement('div');
      splide.className = 'splide js-product-images-splide';

      const track = document.createElement('div');
      track.className = 'splide__track';

      const list = document.createElement('ul');
      list.className = 'splide__list';

      originalItems.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'splide__slide';
        li.appendChild(item);
        list.appendChild(li);
      });

      track.appendChild(list);
      splide.appendChild(track);

      wrapper.innerHTML = '';
      wrapper.appendChild(splide);

      wrapper.classList.remove('d-flex');
      wrapper.classList.add('with-slider');

      return splide;
    }

    function destroyMobile() {
      if (!splideInstance) return;

      const slides = wrapper.querySelectorAll('.splide__slide');
      wrapper.innerHTML = '';

      slides.forEach((slide) => {
        const child = slide.firstElementChild;
        if (child) wrapper.appendChild(child);
      });

      splideInstance.destroy(true);
      splideInstance = null;

      wrapper.classList.remove('with-slider');
      wrapper.classList.add('d-flex');
    }

    function initMobile() {
      if (splideInstance) return;

      if (typeof Splide !== 'function') {
        return;
      }

      const splideRoot = buildSplideStructure();

      splideInstance = new Splide(splideRoot, {
        type: 'slide',
        perPage: 1,
        gap: '12px',
        rewind: true,
        pagination: true,
        arrows: true,
        arrowPath:
          "M12.744 18.9481C12.5878 19.1044 12.5 19.3163 12.5 19.5373C12.5 19.7582 12.5878 19.9702 12.744 20.1264L17.4582 24.8406C17.6153 24.9924 17.8258 25.0764 18.0443 25.0745C18.2628 25.0726 18.4718 24.9849 18.6263 24.8304C18.7808 24.6759 18.8685 24.4669 18.8704 24.2484C18.8723 24.0299 18.7883 23.8194 18.6365 23.6623L15.3448 20.3706H26.3807C26.6017 20.3706 26.8136 20.2828 26.9699 20.1265C27.1262 19.9702 27.214 19.7583 27.214 19.5373C27.214 19.3162 27.1262 19.1043 26.9699 18.948C26.8136 18.7917 26.6017 18.7039 26.3807 18.7039H15.3448L18.6365 15.4123C18.7883 15.2551 18.8723 15.0446 18.8704 14.8261C18.8685 14.6076 18.7808 14.3986 18.6263 14.2441C18.4718 14.0896 18.2628 14.0019 18.0443 14.0001C17.8258 13.9981 17.6153 14.0821 17.4582 14.2339L12.744 18.9481Z",
        breakpoints: {
          576: { perPage: 1 }
        }
      });

      splideInstance.mount();

      const element = splideRoot;
      const splide = splideInstance;
      const track = splideRoot.querySelector(".splide__track");
      const disableAutoHeight = false;

      if (!disableAutoHeight) {
        const computeTargetHeight = () => {
          const visibles = element.querySelectorAll(".splide__slide.is-visible");

          if (visibles.length > 1) {
            let h = 0;
            visibles.forEach((el) => (h = Math.max(h, el.offsetHeight)));
            return h;
          }

          const Slides = splide.Components?.Slides;
          const active =
            Slides?.getAt(splide.index)?.slide ||
            element.querySelector(".splide__slide.is-active");

          return active ? active.offsetHeight : track.offsetHeight || 0;
        };

        const setTrackHeight = (h, animate = true) => {
          if (!track) return;
          if (!animate) track.classList.add("no-anim");
          track.style.height = h ? `${h}px` : "";
          if (!animate) {
            void track.offsetHeight;
            track.classList.remove("no-anim");
          }
        };

        const updateHeight = (animate = true) => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const h = computeTargetHeight();
              if (h) setTrackHeight(h, animate);
            });
          });
        };

        splide.on("mounted", () => updateHeight(false));
        splide.on("moved", () => updateHeight(true));
        splide.on("resized refreshed", () => updateHeight(false));
        splide.on("lazyload:loaded", () => updateHeight(true));

        window.addEventListener("load", () => updateHeight(true));

        element.querySelectorAll("img").forEach((img) => {
          if (!img.complete) {
            img.addEventListener("load", () => updateHeight(true), { once: true });
            img.addEventListener("error", () => updateHeight(true), { once: true });
          }
        });

        splide.on("move", (newIndex) => {
          const Slides = splide.Components?.Slides;
          const destSlide = Slides?.getAt(newIndex)?.slide;
          const h = destSlide?.offsetHeight || computeTargetHeight();
          if (h) setTrackHeight(h, true);
        });
      }
    }

    const applyMode = () => {
      if (window.innerWidth < BREAKPOINT) {
        initMobile();
      } else {
        destroyMobile();
      }
    };

    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyMode, 150);
    };

    window.addEventListener('resize', onResize);

    const observer = new MutationObserver(() => {
      if (!document.body.contains(this)) {
        window.removeEventListener('resize', onResize);
        if (splideInstance) {
          splideInstance.destroy(true);
          splideInstance = null;
        }
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    applyMode();
  }

  productZoom() {
    const zoomContainers = document.querySelectorAll(".product-media p");
    const zoomLevel = 2;

    zoomContainers.forEach(container => {
      const image = container.querySelector("img");

      const onMouseMove = (e) => {
        const rect = container.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        image.style.transformOrigin = `${x}% ${y}%`;
      };

      container.addEventListener("mouseenter", () => {
        image.style.transform = `scale(${zoomLevel})`;
        container.addEventListener("mousemove", onMouseMove);
      });

      container.addEventListener("mouseleave", () => {
        image.style.transform = "scale(1)";
        image.style.transformOrigin = "center center";
        container.removeEventListener("mousemove", onMouseMove);
      });
    });
  }

  productStickyBar() {
    const fixedBar = document.querySelector('.js-product-fixed-bar');
    const addToCart = this.querySelector('.js-product-add-to-cart');
    const mainQtyInput = this.querySelector('.js-quantity-field');
    const footer = document.querySelector('footer'); // <— dodane

    if (!fixedBar || !addToCart || !mainQtyInput || !footer) return;

    const barQtyInput = fixedBar.querySelector('.js-quantity-bar-field');
    const barPlus = fixedBar.querySelector('.js-quantity-bar-up');
    const barMinus = fixedBar.querySelector('.js-quantity-bar-down');

    let isAddToCartOut = false;
    let isFooterVisible = false;

    const observerATC = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        const rect = entry.target.getBoundingClientRect();
        const isAboveViewport = rect.bottom < 0;

        isAddToCartOut = (!entry.isIntersecting && isAboveViewport);
        toggleBar();
      },
      { threshold: 0.01 }
    );
    observerATC.observe(addToCart);

    const observerFooter = new IntersectionObserver(
      (entries) => {
        isFooterVisible = entries[0].isIntersecting;
        toggleBar();
      },
      { threshold: 0 }
    );
    observerFooter.observe(footer);

    function toggleBar() {
      if (isAddToCartOut && !isFooterVisible) {
        fixedBar.classList.add('active');
      } else {
        fixedBar.classList.remove('active');
      }
    }

    const updateQty = (input, delta) => {
      const min = parseInt(input.getAttribute('min') || '1', 10);
      let value = parseInt(input.value || '1', 10);

      value += delta;
      if (value < min) value = min;

      input.value = value;

      mainQtyInput.value = value;
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    };

    barPlus?.addEventListener('click', (e) => {
      e.preventDefault();
      updateQty(barQtyInput, +1);
    });

    barMinus?.addEventListener('click', (e) => {
      e.preventDefault();
      updateQty(barQtyInput, -1);
    });

    barQtyInput?.addEventListener('input', () => {
      let value = parseInt(barQtyInput.value || '1', 10);
      if (isNaN(value) || value < 1) value = 1;

      barQtyInput.value = value;
      mainQtyInput.value = value;
      mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    mainQtyInput?.addEventListener('input', () => {
      barQtyInput.value = mainQtyInput.value;
    });
  }
}

if(document.querySelector("product-page")) {
  customElements.define("product-page", Product);
}